import { render, staticRenderFns } from "./ToStorageTable.vue?vue&type=template&id=5d5577b0&scoped=true"
import script from "./ToStorageTable.vue?vue&type=script&lang=js"
export * from "./ToStorageTable.vue?vue&type=script&lang=js"
import style0 from "./ToStorageTable.vue?vue&type=style&index=0&id=5d5577b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5577b0",
  null
  
)

export default component.exports